<template>
  <div class="row">
    <div class="col-8">
      <q-input
        v-model="qbCustomerId"
        type="number"
        name="quickbooksId"
        class="no-shadow"
        hide-underline
        inverted-light
        :color="inputBgColor"
        @input="updateParent"
      />
    </div>
    <!-- <div class="col-3">
      <q-btn label="Add" icon="add_box" color="positive" class="full-width" @click="handleAdd">
        <q-tooltip>Add Quickbooks</q-tooltip>
      </q-btn>
    </div>-->
    <div class="col-4">
      <q-btn
        label="View/Edit Customer"
        icon="business"
        color="secondary"
        class="full-width"
        @click="externalLink(`customerdetail?nameId=${qbCustomerId}`)"
        :disable="!qbCustomerId"
      >
        <!-- <q-tooltip>Match with existing Quickbooks record</q-tooltip> -->
        <!--https://c50.sandbox.qbo.intuit.com/app/salesreceipt?txnId=212-->
        <!--https://merchantcenter.intuit.com/portal/authsec/portal/qbms/Search+and+reporting/TransactionDetail?transactionId=XXXXXXX-->
      </q-btn>
    </div>
  </div>
</template>
<script>
import colorsMixin from '../../mixins/colors'
import environmentMixin from '../../mixins/environment'
import { openURL } from 'quasar'

export default {
  name: 'QuickbooksCustomer',
  mixins: [colorsMixin, environmentMixin],
  props: {
    value: {
      type: String,
      default: ''
    },
    column: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      qbCustomerId: undefined
    }
  },
  methods: {
    updateParent (value) {
      this.$emit('manual-update', this.column.field, parseInt(value))
    },
    externalLink (url) {
      let finalUrl = this.quickbooksBaseUrl + url
      openURL(finalUrl)
    }
  },
  watch: {
    value: {
      handler (v) {
        this.qbCustomerId = v
      },
      immediate: true
    }
  },
  mounted () {
    if (this.value) {
      this.qbCustomerId = this.value
    }
  }
}
</script>
